import React from 'react';
import { useSelector } from 'react-redux';

import useMontageImgGenerator from 'ugc/hooks/useMontageImgGenerator';
import { useHeightResizePostMessage } from 'client/hooks/useHeightResizePostMessage';

import MontageContainer from 'ugc/components/ugcGallery/montage/MontageContainer';

export default function WrapperMontage({ data }) {
    const montageComponentRef = useMontageImgGenerator();
    const clientBodyRef = useHeightResizePostMessage({ useMaxSize: true });
    const { promoIdOfUgcLink: promoId } = useSelector(s => s.promo);
    const buttonClickLink = `/ugc/${promoId}${window.location.search}${window.location.hash}`;

    return (
        <MontageContainer
            montageComponentRef={montageComponentRef}
            clientBodyRef={clientBodyRef}
            config={data.settingGame.galleryGameSetting}
            buttonLink={buttonClickLink}
        />
    );
}
